module.exports = __webpack_public_path__ + "img/ic_location.6dd98ddc.svg";